export enum UserReportTypes {
  GET_REPORTS_SUCCESS = 'GET_REPORTS_SUCCESS',
  GET_REPORTS_FAILURE = 'GET_REPORTS_FAILURE',
}
